import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';

/** Resso has no `whatIsDescription` — the service shut down in 2024. */
export const resso: MusicService = {
  id: 'resso',
  name: 'Resso',
  shortName: 'Resso',
  isSupported: false,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: true,
  isAlbumTransferSupported: true,
  color: {
    primary: '#FD0164',
    label: '#FD0164',
    background: '#8a6674',
  },
  importerID: ImporterID.Resso,
  musicAPIID: MusicAPIIntegrationID.Resso,
  linkType: 'resso',
  assets: {
    logo: { light: 'resso-light.svg', dark: 'resso-dark.svg' },
    logoPadding: { light: 'resso-light-padding.svg', dark: 'resso-dark-padding.svg' },
    logoColor: { light: 'resso-color-light.svg', dark: 'resso-color-dark.svg' },
    logoColorPadding: {
      light: 'resso-color-light-padding.svg',
      dark: 'resso-color-dark-padding.svg',
    },
    logoOnBackground: 'resso-dark.svg',
  },
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: false,
    doesSupportRemovingPlaylists: false,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: false,
    doesSupportAddingTracksToLibrary: false,
    doesSupportRemovingTracksFromLibrary: false,
    doesSupportFetchingLibraryAlbums: false,
    doesSupportFetchingAlbums: false,
    doesSupportFetchingAlbumTracks: false,
    doesSupportAddingAlbums: false,
    doesSupportRemovingAlbums: false,
    doesSupportFetchingLibraryArtists: false,
    doesSupportFetchingArtists: false,
    doesSupportAddingArtistsToLibrary: false,
    doesSupportRemovingArtistsFromLibrary: false,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: false,
    doesReturnUserCountry: false,
    maxLimit: 50,
  },
};
